(function ($) {
  const NAMESPACE = 'click-off-close';

  $.fn.clickOffClose = function () {
    return this.each(function (index) {
      const $this = $(this);


      const eventName = `click.clickOffClose_${index}`;

      function preventClick(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      function handleClick() {
        $this.fadeOut(250, () => {
          $this.remove();
          $(document).off(eventName);
        });
      }

      $this.on(eventName, preventClick);
      $(document).on(eventName, handleClick);
    });
  };

  $(() => {
    $(`[data-plugin=${NAMESPACE}]`).clickOffClose();
  });
}(jQuery));
